import React from 'react';
import _ from 'lodash';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

export default function ConfirmCookie() {
  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    localStorage.setItem('acceptCookie', true);
    setOpen(false);
  };

  React.useEffect(() => {
    const acceptCookie = localStorage.getItem('acceptCookie');

    if (acceptCookie !== 'true') {
      setOpen(true);
    }

  }, []);

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
    >
      <DialogTitle>
        Pliki cookie
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
        Chcielibyśmy, aby nasz Serwis w pełni spełniał Twoje oczekiwania. W tym celu wykorzystujemy pliki cookies, które będą zapisywane w Twoim komputerze lub urządzeniu mobilnym. W każdym momencie możesz dokonać zmiany ustawień swojej przeglądarki internetowej i zmienić opcję zapisu plików cookies. Takie zmiany mogą jednak powodować nieprawidłowe działanie niektórych funkcji Serwisu SUN-SPORT.PL Zapoznaj się ze szczegółowymi informacjami dotyczącymi wykorzystywania plików cookies w naszym Serwisie, która dostępna jest <a href="https://sun-sport.pl/polityka-prywatnosci-sunsport/" target="_blank" rel="noopener noreferrer">TUTAJ</a>.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={handleClick}>Akceptuję pliki cookies i przechodzę do SUN-SPORT.PL</Button>
      </DialogActions>
    </Dialog>
  );
}
